module.exports = __webpack_public_path__ + "static/media/yogaTrainer-mobile-cover.918974b1.png";